import { render, staticRenderFns } from "./ActionGuidanceWorkItemPage.vue?vue&type=template&id=33969693&scoped=true&"
import script from "./ActionGuidanceWorkItemPage.vue?vue&type=script&lang=js&"
export * from "./ActionGuidanceWorkItemPage.vue?vue&type=script&lang=js&"
import style0 from "./ActionGuidanceWorkItemPage.vue?vue&type=style&index=0&id=33969693&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33969693",
  null
  
)

export default component.exports